import { useContext } from "react";
import { ThemeContext } from "../contexts/theme-context";

/**
 * Them related implementation
 * @returns
 */
const useTheme = () => useContext(ThemeContext);
//
export default useTheme;
